module.exports = "/static/assets/05649236fbbcee12a260894921755795.gif";